import React, { Component } from 'react';
import HeaderTwo from './components/HeaderTwo';
import ServiceBox from './components/cozy/home/ServiceBox';
import AboutUsTwo from './components/cozy/home/AboutUsTwo';
import CourseSlider from './components/cozy/home/CourseSlider';
import FooterTwo from './components/FooterTwo';
import HeroSlider from "./components/cozy/home/HeroSlider";
import TeamSlider from "./components/cozy/home/TeamSlider";
import TeamSlider2 from "./components/cozy/home/TeamSlider2";
import FreeCourse1 from './components/cozy/home/FreeCourse1';
import FreeCourse2 from './components/cozy/home/FreeCourse2';

export default class HomeTwo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPlaying: false,
            isMuted: false,
            isMobile: false,
        };
        // Initialize audio object
        this.audio = new Audio('/assets/Cozy_Calm_Mountains.mp3');
        this.audio.loop = true;
        this.audio.volume = 0.6; // Set a reasonable volume
        this.audio.preload = 'auto';
    }

    componentDidMount() {
        // Add event listeners for audio state changes
        this.audio.addEventListener('play', this.handleAudioPlay);
        this.audio.addEventListener('pause', this.handleAudioPause);
        this.audio.addEventListener('ended', this.handleAudioPause);
        this.audio.addEventListener('error', this.handleAudioError);

        // Check screen size for mobile detection
        this.setState({ isMobile: window.innerWidth <= 767 });
    }

    componentWillUnmount() {
        // Clean up audio and event listeners
        this.audio.removeEventListener('play', this.handleAudioPlay);
        this.audio.removeEventListener('pause', this.handleAudioPause);
        this.audio.removeEventListener('ended', this.handleAudioPause);
        this.audio.removeEventListener('error', this.handleAudioError);

        this.audio.pause();
        this.audio.currentTime = 0;
    }

    handleAudioPlay = () => {
        this.setState({
            isPlaying: true,
            isMuted: false
        });
    };

    handleAudioPause = () => {
        this.setState({
            isPlaying: false
        });
    };

    handleAudioError = (error) => {
        console.log("Audio error:", error);
        this.setState({
            isPlaying: false
        });
    };

    handleAudioToggle = () => {
        if (this.state.isPlaying) {
            // If audio is playing, pause it
            this.audio.pause();
        } else {
            // If audio is paused, play it
            this.audio.play().catch((error) => {
                console.log("Audio play failed:", error);
            });
        }
    };

    render() {
        return (
            <div className="main-wrapper">
                <style dangerouslySetInnerHTML={{
                    __html: `
                        .audio-control-btn {
                            position: fixed;
                            bottom: 40px;
                            right: 85px;
                            width: 45px;
                            height: 45px;
                            border-radius: 5px;
                            border: none;
                            color: #ffffff;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 18px;
                            text-decoration: none;
                            z-index: 1000;
                            opacity: 1;
                            pointer-events: auto;
                            transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
                            box-shadow: 0 4px 15px rgba(0,0,0,0.2);
                            transform: scale(1);
                            outline: none;
                        }
                        
                        .audio-control-btn:hover {
                            transform: scale(1.1);
                            box-shadow: 0 8px 25px rgba(0,0,0,0.3);
                        }
                        
                        .audio-control-btn:active {
                            transform: scale(0.95);
                            transition: all 0.1s ease;
                        }
                        
                        .audio-control-btn i {
                            transition: all 0.3s ease;
                        }
                        
                        @keyframes pulse {
                            0% {
                                box-shadow: 0 4px 15px rgba(0,0,0,0.2), 0 0 0 0 rgba(17, 182, 122, 0.7);
                            }
                            70% {
                                box-shadow: 0 4px 15px rgba(0,0,0,0.2), 0 0 0 10px rgba(17, 182, 122, 0);
                            }
                            100% {
                                box-shadow: 0 4px 15px rgba(0,0,0,0.2), 0 0 0 0 rgba(17, 182, 122, 0);
                            }
                        }
                        
                        .audio-playing {
                            animation: pulse 2s infinite;
                        }
                    `
                }} />
                
                {/* Floating Audio Control Button */}
                <button
                    onClick={this.handleAudioToggle}
                    className={`audio-control-btn ${this.state.isPlaying ? 'audio-playing' : ''}`}
                    style={{
                        background: this.state.isPlaying
                            ? 'linear-gradient(90deg, #11B67A 0%, #009444 100%)'
                            : 'linear-gradient(135deg, #ff6b6b 0%, #ff4757 50%, #ff3742 100%)'
                    }}
                    title={this.state.isPlaying ? 'Pause sound' : 'Play sound'}
                >
                    {this.state.isPlaying ? (
                        <i className="las la-pause"></i>
                    ) : (
                        <i className="las la-play" style={{ marginLeft: '2px' }}></i>
                    )}
                </button>

                {/* Header 2 */}
                <HeaderTwo/>

                {/* Slider */}
                <HeroSlider/>

                {/* About Us 2 */}
                <AboutUsTwo/>

                {/* Our Products */}
                <TeamSlider/>

                {/* Our Services */}
                <ServiceBox/>

                {/* How we work */}
                <FreeCourse1/>

                {/* Why choose us */}
                <TeamSlider2/>

                {/* Our Values */}
                <FreeCourse2/>

                {/* Our Clients*/}
                <CourseSlider/>

                {/* Footer 2 */}
                <FooterTwo/>
            </div>
        );
    }
}